import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-color-chip-autocomplete-details',
    templateUrl: './color-chip-autocomplete-details.component.html',
    styleUrls: ['./color-chip-autocomplete-details.component.scss'],
    standalone: false
})
export class ColorChipAutoCompleteDetailsComponent {
  @Input() separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() selectedColors: string[] = [];
  @Input() filteredColors: Observable<string[]>;
  @Input() color: string;
  @Input() add!: (event: MatChipInputEvent) => void;
  @Input() remove!: (fruit: string) => void;
  @Input() selected!: (event: MatAutocompleteSelectedEvent) => void;
  @Input() isEditModal: boolean;

  @ViewChild('colorInput') colorInput: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    (this.selected as any).colorInput = this.colorInput
  }
}